// extracted by mini-css-extract-plugin
export var container = "_eq-0";
export var icon = "_eq-1";
export var text = "_eq-2";